// translations/index.js
import { en } from './en';
import { it } from './it';

export const translations = {
  en,
  it
};

export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' }
];

export default translations;